var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedCardShuffling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4545 165C44.7078 165.077 39.1786 160.386 38.2434 153.774C35.5523 134.729 32.898 115.677 30.2191 96.6284C28.5448 84.7181 26.8542 72.8077 25.1513 60.9014C24.0569 53.2544 29.0226 46.7719 36.6794 45.7172C51.6051 43.6609 66.5226 41.5313 81.4401 39.4383C85.8259 38.8235 90.2077 38.1801 94.6016 37.6182C101.732 36.702 108.131 41.8041 109.156 49.101C111.978 69.2041 114.828 89.303 117.662 109.406C119.193 120.262 120.741 131.113 122.244 141.973C123.248 149.238 118.434 155.7 111.12 156.75C95.9043 158.941 80.6724 161.038 65.4527 163.172C60.7687 163.827 56.0807 164.491 52.4586 165.004L52.4545 165ZM71.8395 88.1873C71.3372 87.9023 70.9084 87.6458 70.4715 87.4055C65.3342 84.5715 58.9515 86.0455 55.558 90.8504C52.189 95.6186 52.8955 102.28 57.4487 105.965C61.9897 109.638 66.7104 113.095 71.4474 116.52C74.1876 118.503 77.8996 118.026 79.97 115.4C83.6453 110.734 87.2634 106.014 90.6977 101.169C93.3643 97.4102 93.2173 92.3366 90.5303 88.5782C87.7044 84.6244 83.8045 83.016 78.9654 83.8141C76.0211 84.3027 73.7384 85.9233 71.8395 88.1873ZM103.467 137.36C102.581 136.077 101.887 135.027 101.148 134.017C99.8859 132.286 98.0809 131.867 96.5128 132.901C94.8997 133.964 94.5771 135.906 95.7941 137.71C97.7256 140.568 99.7062 143.398 101.666 146.241C102.45 147.377 103.524 148.004 104.913 147.804C106.285 147.605 107.191 146.762 107.637 145.443C108.768 142.083 109.923 138.728 111.018 135.356C111.618 133.508 110.728 131.72 109.029 131.17C107.281 130.604 105.587 131.447 104.88 133.292C104.411 134.522 104.014 135.776 103.471 137.36H103.467ZM43.8952 65.2339C44.765 66.4799 45.4878 67.5631 46.2637 68.6096C47.5092 70.2953 49.3877 70.6822 50.9231 69.6072C52.4259 68.5525 52.7771 66.712 51.6622 65.0385C49.7225 62.1271 47.7093 59.2604 45.7124 56.3897C44.9202 55.2537 43.7972 54.7162 42.4169 54.9279C41.0489 55.1356 40.126 55.9337 39.6809 57.2652C38.5865 60.5309 37.4553 63.7803 36.3895 67.0541C35.7442 69.0412 36.561 70.7677 38.3333 71.3785C40.1219 71.9974 41.8003 71.1301 42.5353 69.1633C42.9927 67.9458 43.3929 66.708 43.9033 65.238L43.8952 65.2339Z",
    fill: "url(#paint0_linear_26_101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.139 35.1018C108.853 35.057 109.286 35.0122 109.723 35.0122C116.041 35.0081 122.358 34.9919 128.675 35.0122C136.887 35.0367 142.421 40.493 142.425 48.6613C142.445 79.6404 142.445 110.62 142.425 141.599C142.421 149.775 136.9 155.231 128.7 155.276C127.65 155.28 126.597 155.276 125.698 155.276C126.638 152.784 127.712 150.439 128.406 147.988C129.512 144.058 128.557 140.121 128.014 136.212C126.233 123.446 124.424 110.685 122.623 97.9233C120.835 85.2637 119.046 72.6001 117.257 59.9405C116.71 56.0722 116.143 52.2079 115.624 48.3315C114.987 43.5673 112.945 39.5402 109.413 36.2704C109.057 35.9406 108.702 35.6149 108.147 35.1018H108.139Z",
    fill: "url(#paint1_linear_26_101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.555 43.6365C153.81 44.3735 158.915 44.9884 163.982 45.8231C171.337 47.0366 175.899 53.5109 174.849 60.9585C171.688 83.3255 168.54 105.693 165.387 128.06C164.183 136.602 162.974 145.149 161.761 153.692C160.781 160.606 155.015 165.546 147.938 164.919C140.959 164.3 134.033 163.107 127.099 161.926C128.541 161.836 129.986 161.799 131.42 161.653C141.261 160.647 148.889 152.418 148.906 142.535C148.959 110.933 148.93 79.3309 148.906 47.7329C148.906 46.4258 148.685 45.1228 148.555 43.6324V43.6365Z",
    fill: "url(#paint2_linear_26_101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_101",
    x1: 73.6883,
    y1: 37.5118,
    x2: 73.6883,
    y2: 165.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_101",
    x1: 125.289,
    y1: 35.0022,
    x2: 125.289,
    y2: 155.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_101",
    x1: 151.049,
    y1: 43.6324,
    x2: 151.049,
    y2: 164.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 130,
    fill: "white",
    transform: "translate(25 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedCardShuffling);
export default __webpack_public_path__ + "static/media/Advanced_Card_Shuffling.57617af5f281c1515d0a9864fa54c112.svg";
export { ForwardRef as ReactComponent };